/**
 * Centralized translations for the wind farms page.
 */
const fr = {
  notAvailable: 'n.d.',
  noResults: 'Aucun résultat.',
  nameKey: 'nom-fr',

  map: {
    ariaLabel: 'Carte des parcs éoliens du Québec',
  },

  list: {
    labelPower: 'Puissance',
    labelOwners: 'Propriétaire(s)',
    labelOperationPeriod: 'Durée d’opération',
    operationSincePrefix: 'Depuis',
  },

  popup: {
    labelPower: 'Puissance',
    labelOwners: 'Propriétaire(s)',
    labelOperationPeriod: 'Durée d’opération',
    operationSincePrefix: 'Depuis',
    close: 'Fermer',
  },

  status: {
    etude: 'À l\'étude',
    'en-chantier': 'En chantier',
    'en-service': 'En service',
    annule: 'Annulé',
    'en-veille': 'En veille',
    complete: 'Complété',
    'en-evaluation': 'En évaluation',
    'en-developpement': 'En développement',
    'en-operation': 'En opération',
  },

  pagination: {
    ariaLabel: 'Pagination',
    previous: 'Page précédente',
    next: 'Page suivante',
    /** @param {number} n */
    page: (n) => `Page\u00a0${n}`,
  },

  view: {
    param: 'vue',
  },

  count: {
    /** @param {number} n */
    unit: (n) => (n === 1 ? 'parc éolien' : 'parcs éoliens'),
  },
};

const en = {
  noResults: 'No results.',
  notAvailable: 'N/A',
  nameKey: 'nom-en',

  map: {
    ariaLabel: "Map of Quebec's wind farms",
  },

  list: {
    labelPower: 'Capacity',
    labelOwners: 'Owners',
    labelOperationPeriod: 'Period of operation',
    operationSincePrefix: 'Since',
  },

  popup: {
    labelPower: 'Capacity',
    labelOwners: 'Owners',
    labelOperationPeriod: 'In service',
    operationSincePrefix: 'Since',
    close: 'Close',
  },

  status: {
    etude: 'Under study',
    'en-chantier': 'Under construction',
    'en-service': 'In service',
    annule: 'Cancelled',
    'en-veille': 'On hold',
    complete: 'Completed',
    'en-evaluation': 'Under assessment',
    'en-developpement': 'In development',
    'en-operation': 'In operation',
  },

  pagination: {
    ariaLabel: 'Pagination',
    previous: 'Previous page',
    next: 'Next page',
    /** @param {number} n */
    page: (n) => `Page\u00a0${n}`,
  },

  view: {
    param: 'view',
  },

  count: {
    /** @param {number} n */
    unit: (n) => (n === 1 ? 'wind farm' : 'wind farms'),
  },
};

const dictionaries = { fr, en };

/**
 * Returns the dictionary for the given language, falling back to French.
 * @param {string} lang - e.g. 'fr', 'en', 'fr-CA'
 * @returns {typeof fr}
 */
export function getDictionary(lang = 'fr') {
  const key = lang.split('-')[0].toLowerCase();
  return dictionaries[key] ?? fr;
}

const dictionary = getDictionary(document.documentElement.lang);

/**
 * Returns the value at the given dot-notation key path.
 * @param {string} key - e.g. 'list.noResults', 'pagination.pageAria'
 * @returns {*}
 */
export const t = (key) => key.split('.').reduce((obj, k) => obj?.[k], dictionary);
